import { AiOutlineLoading } from "react-icons/ai";
import { MdErrorOutline } from "react-icons/md";

/*
  Rodapé de formulário em modal: fica colado na base da área rolável.

  O botão de salvar do formulário de cliente ficava no fim do conteúdo — numa
  aba longa como Horários era preciso rolar até o fim para salvar, e em telas
  menores ele sumia abaixo da dobra sem indicação de que existia.

  A mensagem de erro mora aqui, ao lado do botão, e não no topo: é onde a
  pessoa está olhando quando o clique não produz o efeito esperado.
*/

const FormFooter = ({
  isSubmitting,
  label,
  hint,
  error,
  disabled = false,
}) => (
  <div className="sticky bottom-0 -mx-5 -mb-4 mt-5 border-t border-slate-100 bg-white px-5 py-3">
    {error ? (
      <p className="mb-2 flex items-start gap-1.5 rounded-xl bg-rose-50 px-3 py-2 text-xs font-semibold text-rose-800 ring-1 ring-inset ring-rose-200">
        <MdErrorOutline size={14} className="mt-px shrink-0" />
        {error}
      </p>
    ) : null}

    <button
      type="submit"
      disabled={isSubmitting || disabled}
      className="flex w-full items-center justify-center gap-2 rounded-xl bg-pink-600 py-2.5 text-sm font-semibold text-white transition hover:bg-pink-700 disabled:opacity-50"
    >
      {isSubmitting ? (
        <AiOutlineLoading className="h-4 w-4 animate-spin" />
      ) : null}
      {isSubmitting ? "Salvando..." : label}
    </button>

    {hint ? (
      <p className="mt-1.5 text-center text-[11px] text-slate-400">{hint}</p>
    ) : null}
  </div>
);

export default FormFooter;
